
'use strict'

if (process.env.NODE_ENV === 'production') {
  module.exports = require('./immer.cjs.production.js')
} else {
  module.exports = require('./immer.cjs.development.js')
}